import {useEffect} from "react";
import {FormProvider} from "react-hook-form";

import {RegisterSubmit} from "../../../../hooks/use_registered_submit";
import {UserPhoneNumberInput} from "../../../user/components/modal/UserPhoneNumberInput";
import {usePhoneNumberPatchForm} from "../../../user/hooks/use_phone_number_patch_form";

interface IProps {
    onRegisterSubmit: RegisterSubmit;
    onSaved: (phone: string) => void;
    onSubmittingChange: (isSubmitting: boolean) => void;
}

export const HomeMatchPreferencesWizardPhoneStep = (props: IProps) => {
    const {onRegisterSubmit, onSaved, onSubmittingChange} = props;
    const {form, isSubmitting, onSubmit} = usePhoneNumberPatchForm({onPhoneNumberSaved: onSaved});

    useEffect(() => {
        onSubmittingChange(isSubmitting);
    }, [isSubmitting, onSubmittingChange]);

    useEffect(() => {
        onRegisterSubmit(() => onSubmit());

        return () => onRegisterSubmit(null);
    }, [onRegisterSubmit, onSubmit]);

    return (
        <FormProvider {...form}>
            <UserPhoneNumberInput />
        </FormProvider>
    );
};
import {useEffect} from "react";
import {FormProvider} from "react-hook-form";

import {RegisterSubmit} from "../../../../hooks/use_registered_submit";
import {UserPhoneNumberInput} from "../../../user/components/modal/UserPhoneNumberInput";
import {usePhoneNumberPatchForm} from "../../../user/hooks/use_phone_number_patch_form";

interface IProps {
    onRegisterSubmit: RegisterSubmit;
    onSaved: (phone: string) => void;
    onSubmittingChange: (isSubmitting: boolean) => void;
}

export const HomeMatchPreferencesWizardPhoneStep = (props: IProps) => {
    const {onRegisterSubmit, onSaved, onSubmittingChange} = props;
    const {form, isSubmitting, onSubmit} = usePhoneNumberPatchForm({onPhoneNumberSaved: onSaved});

    useEffect(() => {
        onSubmittingChange(isSubmitting);
    }, [isSubmitting, onSubmittingChange]);

    useEffect(() => {
        onRegisterSubmit(() => onSubmit());

        return () => onRegisterSubmit(null);
    }, [onRegisterSubmit, onSubmit]);

    return (
        <FormProvider {...form}>
            <UserPhoneNumberInput />
        </FormProvider>
    );
};
